import { Component, Vue } from "vue-property-decorator";
import { QUERY_PARAMS } from "@/data/constants";
import { getSessionItem, removeSessionItem } from "@/helpers/sessionStorage";
import { DataModules } from "@/store/modules/data";

interface IOperation {
  procedure: string;
  params: string[];
  meta: Record<string, any>;
}

@Component
export default class GatewayOperationHandlerMixin extends Vue {
  public operation: IOperation | null = null;
  public operationId = this.$route.query?.[QUERY_PARAMS.OPERATION_ID];
  public operationKey = ["op", this.operationId].join("::");

  // Life-cycle methods

  public async created() {
    this.operation = getSessionItem(this.operationKey, null);
    if (!this.operation) return this.endOperation();

    try {
      switch (this.operation.procedure) {
        case "endAsyncSetup":
          await this.gateway_endAsyncSetup();
          break;
        default:
          return;
      }
    } catch (error) {
      this.$store.dispatch("api/handleError", error);
    } finally {
      this.endOperation();
    }
  }

  // Methods

  public endOperation() {
    // Remove operation data from sessionStorage
    removeSessionItem(this.operationKey);
    // Get params to clear
    const paramsToClear = [
      QUERY_PARAMS.OPERATION_ID,
      ...(this.operation?.params || [])
    ];
    // Create new route query
    const query = this.$_.omit({ ...this.$route.query }, paramsToClear);
    // Silently replace current router query
    this.$router.replace({ query }).catch(err => err);
  }

  // Gateway-Specific Methods

  public async gateway_endAsyncSetup() {
    await this.$store.dispatch(`data/${DataModules.GATEWAYS}/endAsyncSetup`, {
      vm: this,
      ...this.operation?.meta
    });
    this.$bus.$emit("refreshPaymentMethods");
  }
}
